module.exports = __webpack_public_path__ + "media/images/maxicare-c397539da82bc2499e96dcd2a2c3f88f.png";